export const OFFER_NAV = [
  {
    "title": "Dapatkan Penawaran",
    "rel": "offer",
    "position": "right",
    "dropdownPos": "right",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Kesehatan Terbaik",
        "link": "/produk/asuransi-kesehatan/",
      },
    ],
  }
];